function initGalleryCustomScroll() {
  if (window.innerWidth < 990) return;
  const containerMaster = document.querySelector('.js-product-gallery');
  const containerScrollable = document.querySelector('.js-product-gallery keen-slider-component');
  const customScrollbar = document.querySelector('.js-custom-scrollbar');
  const scrollThumb = document.querySelector('.js-scroll-thumb');
  const scrollTrack = document.querySelector('.js-scroll-track');
  const scrollUpButton = document.querySelector('.js-scroll-up');
  const scrollDownButton = document.querySelector('.js-scroll-down');

  if (!containerMaster || !containerScrollable || !customScrollbar || !scrollThumb || !scrollTrack) return;

  let contentScrollableHeight, scrollRatio;

  function updateScrollMetrics() {
    containerMaster.style.height = '';
    const containerScrollableHeight = containerScrollable.offsetHeight;
    contentScrollableHeight = containerScrollable.scrollHeight;
    scrollRatio = containerScrollableHeight / contentScrollableHeight;

    if (scrollRatio >= 1) {
      customScrollbar.classList.remove('is-initialized');
      containerMaster.style.height = 'auto';
    } else {
      customScrollbar.classList.add('is-initialized');
      scrollThumb.style.height = `${scrollRatio * scrollTrack.offsetHeight}px`;
      updateThumbPosition(); // in case scrollTop is not 0
    }
  }

  function updateThumbPosition() {
    const scrollTop = containerScrollable.scrollTop;
    const thumbPosition = (scrollTop / contentScrollableHeight) * scrollTrack.offsetHeight;
    scrollThumb.style.top = `${thumbPosition}px`;
  }

  // Scroll via buttons
  scrollUpButton?.addEventListener('click', () => {
    containerScrollable.scrollTop -= 100;
    updateThumbPosition();
  });

  scrollDownButton?.addEventListener('click', () => {
    containerScrollable.scrollTop += 100;
    updateThumbPosition();
  });

  // On scroll
  containerScrollable.addEventListener('scroll', updateThumbPosition);

  // Dragging
  let isDragging = false;
  let startY = 0;
  let startScrollTop = 0;

  scrollThumb.addEventListener('mousedown', (e) => {
    isDragging = true;
    startY = e.pageY;
    startScrollTop = containerScrollable.scrollTop;
    e.preventDefault();
  });

  document.addEventListener('mousemove', (e) => {
    if (isDragging) {
      const delta = e.pageY - startY;
      const scrollDelta = (delta / scrollTrack.offsetHeight) * contentScrollableHeight;
      containerScrollable.scrollTop = startScrollTop + scrollDelta;
      updateThumbPosition();
    }
  });

  document.addEventListener('mouseup', () => {
    isDragging = false;
  });

  // Observe container for size/content changes
  const resizeObserver = new ResizeObserver(updateScrollMetrics);
  resizeObserver.observe(containerScrollable);

  // Initial metrics
  updateScrollMetrics();
}

// Init on DOM ready
document.addEventListener('DOMContentLoaded', initGalleryCustomScroll);
